export interface QuestionItem {
  title: string
  body: string
}

export const questions: QuestionItem[] = [
  {
    title: 'Who is Vera Reserve for?',
    body: "People who've built something and let it run them. You already know what a good week looks like. What you don't have is room to plan it, coordinate it, and hold it together across a travel schedule and a business. Reserve is for the point where the information was never the problem.",
  },
  {
    title: 'Is this a medical service?',
    body: "No. I'm a board-certified health coach through the NBHWC. I don't diagnose, treat, prescribe, or manage medical conditions, and I don't order or interpret labs. What I do is coordinate. If you have physicians or specialists, I work alongside them and build your training and nutrition around what they've told you. If you don't, and something in our work suggests you should, I'll say so directly and help you get in front of the right person.",
  },
  {
    title: 'What happens in the first week?',
    body: 'We complete your assessment, map your schedule and travel patterns, bring your assistant into the loop, set your standing call time and check-in day, build your initial training program and nutrition strategy, and create your travel protocol template. By day seven the infrastructure exists. From there it runs.',
  },
  {
    title: 'How many clients do you take at one time?',
    body: "Eight. That number isn't a marketing device, it's the ceiling on what this level of service can be delivered at without degrading. When the seats are full, the list closes.",
  },
  {
    title: 'What kind of access do I have?',
    body: "Messages are checked daily during business hours. Logistics and travel requests are confirmed within 24 hours. Larger strategy changes are handled at your weekly call unless something is urgent. I'd rather tell you exactly what to expect than promise round-the-clock access and deliver something less.",
  },
  {
    title: 'Do you work with my assistant?',
    body: "Yes, and it's one of the reasons this works. Your EA receives monthly priorities, weekly logistics, travel instructions, and confirmations. Scheduling and coordination happen between us so you're not the message relay for your own health.",
  },
  {
    title: 'Can my partner participate?',
    body: "Yes. Reserve is built around your household, not just your calendar. Your partner is welcome inside your seat: shared travel plans, shared restaurant lists, and training built for two where it makes sense. Health that only works when you're alone isn't a system, and the people closest to you shouldn't have to live around your protocol.",
  },
  {
    title: "What's the commitment?",
    body: "Reserve begins with a twelve-month initial term. The first weeks build infrastructure and the value compounds from there, so this isn't a thing you try for a month.",
  },
  {
    title: 'Is what I share private?',
    body: "Yes. Discretion is a standing operating condition, not a feature. Nothing about your health, your business, or your household is discussed outside our work. If you need a written confidentiality agreement, I'll sign one.",
  },
  {
    title: 'How do I apply?',
    body: "Reserve is application only. You submit an application, we have a conversation, and we both decide whether it's the right fit. If it isn't, I'll tell you and point you somewhere better.",
  },
]
